module.exports = __webpack_public_path__ + "static/media/data_flow.2ef8d4b7.png";